import Button from "@material-ui/core/Button";
import LinearProgress from "@material-ui/core/LinearProgress";
import { Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import { CSSProperties } from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
// import Assignment from "@material-ui/icons/Assignment";
import * as React from "react";
import { RouterProps } from "react-router";
import Component from "src/shared/components/Component";
import MobilePage from "src/shared/components/MobilePage";
import withAxios, { IAxiosProps } from "src/shared/components/withAxios";
import { ResponseSource } from "src/api/types";
import { IRespondentPagePassedDown } from "../RespondentPage";
import { Box } from "@material-ui/core";

const styles = (theme: Theme): Record<string, CSSProperties> => ({
  coachName: {
    fontSize: "22px",
  },
});

interface INameInputPageProps {
  code: string;
  respondentNameChange: (v: React.ChangeEvent<HTMLInputElement>) => void;
  respondentName: string;
  coachId?: number;
  forVideoMidSeson: boolean;
  schoolData:any;
}

type IProps = INameInputPageProps &
  RouterProps &
  IRespondentPagePassedDown &
  IAxiosProps &
  WithStyles<keyof ReturnType<typeof styles>>;

interface IInputInformationState {
  selectedCoachId?: number;
}

export default withStyles(styles)(
  withAxios(
    class NameInputPage extends Component<IProps, IInputInformationState> {
      public readonly state = this.buildState({
        selectedCoachId: undefined,
      });

      public componentDidMount() {
        const { code, loadSurvey } = this.props;
        loadSurvey(code);
      }

      public componentDidUpdate(prevProps: IProps) {
        const { surveyResponse, responseSource, history, coachId, code } =
          this.props;

        // check if a coach is in the coachs list. If not then send the user back
        // This should only happen if a user is foolish enough to type in the url the coachId
        // or if the survey is finished/not valid
        if (
          surveyResponse !== undefined &&
          !surveyResponse.coaches.find((c) => c.id === coachId)
        ) {
          history.push(`/${ResponseSource[responseSource]}/${code}`);
        }
      }

      // render for both students and coaches
      public render() {
        const {
          responseSource,
          surveyResponse,
          // school,
          loadingSurvey,
          coachId,
        } = this.props;
        if (surveyResponse === undefined) {
          if (loadingSurvey) {
            return <LinearProgress variant="query" />;
          }
          return <h1>Oops… something went wrong. Survey not loaded.</h1>;
        }

        const coach = surveyResponse.coaches.find((c) => c.id === coachId);
        if (coach === undefined) {
          return <h1>Oops… something went wrong. {this.props?.schoolData?.isAdSurvey ? "AD" :"Coach"} was not found.</h1>;
        }

        // const sportName = (() => {
        //   if (
        //     surveyResponse === undefined ||
        //     surveyResponse.sport === undefined
        //   ) {
        //     return ``;
        //   } else {
        //     return `${surveyResponse.sport.name}`;
        //   }
        // })();
        
        switch (responseSource) {
          case ResponseSource.student:
            return (
              <MobilePage
                header={this.props?.schoolData?.name || ''}
                title="Enter your name"
                subtitle=""
                schoolLogo={this.props?.schoolData?.logo1 || ''}
                schoolLogo2={this.props?.schoolData?.logo2 || ''}
                schoolName={this.props?.schoolData?.name || ''}
                tagline={this.props?.schoolData?.tagline || ''}
                showSurveyHeader={false}
                compactSurveyLayout={true}
                sportName={surveyResponse?.sport?.name || ''}
              >
                {this.renderNameChange()}
              </MobilePage>
            );
          case ResponseSource.coach:
            return (
              <div>
                <span> {this.props?.schoolData?.isAdSurvey ? "AD's" :"Coaches"} do not need this page</span>
              </div>
            );
          case ResponseSource.parent:
            return (
              <MobilePage
                header={this.props?.schoolData?.name || ''}
                title="Enter your name"
                subtitle=""
                schoolLogo={this.props?.schoolData?.logo1 || ''}
                schoolLogo2={this.props?.schoolData?.logo2 || ''}
                schoolName={this.props?.schoolData?.name || ''}
                tagline={this.props?.schoolData?.tagline || ''}
                showSurveyHeader={false}
                compactSurveyLayout={true}
                sportName={surveyResponse?.sport?.name || ''}
              >
                {this.renderNameChange()}
              </MobilePage>
            );
          default:
            return <span>Something is wrong</span>;
        }
      }

      private renderNameChange() {
        const { respondentNameChange, respondentName, responseSource, forVideoMidSeson, schoolData } =
          this.props;
        const confidentialityMessage = (() => {
          switch (responseSource) {
            case ResponseSource.student:
              return forVideoMidSeson ? `This survey gives you a direct connection to your leader, who will see your individual responses. They want your honest input to understand how you feel and how to better support you and the team. By sharing openly and honestly, we can work together to build something better, together.`
              : `Your feedback is important to us. Please take a moment to thoughtfully answer the following questions so we can better understand your perspective.`;
            case ResponseSource.parent:
              return forVideoMidSeson ? `Parents, this survey allows you to provide feedback directly to your coach. Just like with your child, growth happens through encouragement and honesty. Your coach will see your responses, so be respectful yet truthful—just as you would want your child to be treated with care and guided with honesty.` :
              schoolData?.isAdSurvey ? `As we work to strengthen our athletic program and culture, your voice is incredibly important. Including your name helps us better understand feedback, follow up when needed, and celebrate positive contributions.
Anonymous responses make it difficult to take meaningful action, and for this process to help us grow, we need to know who’s sharing what. Surveys without a name may not be considered valid.
Thank you for partnering with us to build a stronger, more connected athletic community.`:
              `Your name and answers will be seen by the athletic department. Your name and answers will be held confidential from the ${this.props?.schoolData?.isAdSurvey ? "AD" :"coach"}. All written answers will be searched for themes and will not be quoted verbatim. Your answers will remain confidential from ${this.props?.schoolData?.isAdSurvey ? "AD's" :"Coaches"}, but the athletic department will have option to see the name associated with your answer.`;
            default:
              return `Oops… you should not be seeing this page. Please report this issue to an administrator.`;
          }
        })();
        return (
          <div>
            <Typography style={{ fontSize: 13, lineHeight: 1.35 }}>{confidentialityMessage}</Typography>
            <div style={{ paddingTop: "12px", fontSize: 14, fontWeight: 700 }}>First and Last Name</div>
            <form onSubmit={this.submitName}>
              <TextField
                fullWidth={true}
                onChange={respondentNameChange}
                value={respondentName}
                variant="outlined"
                placeholder="Enter your first and last name"
                size="small"
                style={{ marginTop: 8 }}
              />
              <Box marginTop="1rem">
                <div className="submit-btn-primary">
                <Button
                  type="submit"
                  disabled={respondentName === ""}
                  variant="contained"
                  color="primary"
                >
                  Submit Name
                </Button>
                </div>
              </Box>
            </form>
          </div>
        );
      }

      private submitName = async (e: React.FormEvent) => {
        e.preventDefault();
        const { responseSource, code, coachId } = this.props;
        this.props.history.push(
          `/${ResponseSource[responseSource]}/${code}/${coachId}/${0}`
        );
      };
    }
  )
);



// WEBPACK FOOTER //
// ./src/features/respondent/pages/NameInputPage.tsx